// extracted by mini-css-extract-plugin
module.exports = {"no-returned-vehicles":"SalesVehicleList_no-returned-vehicles__2PkEp","list":"SalesVehicleList_list__3So69","fixed-content-column":"SalesVehicleList_fixed-content-column__33kOj"};